import React from 'react';

import { useWebformContext } from '../../../../context/WebformContext';
import Logo from '../../../Logo';

import './style.scss';

const WebformAssessmentHeader: React.FC = () => {
  const root = document.documentElement;
  const { currentPage, pages } = useWebformContext();

  root.style.setProperty('--total-pages', String(pages.length));
  root.style.setProperty('--current-page', String(pages.indexOf(currentPage) + 1));

  return (
    <div className="WebformAssessment__Header">
      <div className="WebformAssessment__Header__progressbar" />
      <div className="WebformAssessment__Header__wrapper">
        <Logo />
      </div>
    </div>
  );
};

export default WebformAssessmentHeader;
